export type PlanBadgeMode = 'header' | 'active' | 'current';

export function formatPlanId(id: string | null | undefined): string {
    if (id == null || String(id).trim() === '') return '—';
    return String(id).trim().toUpperCase();
}

export function planBadgeLabel(
    mode: PlanBadgeMode,
    planId?: string | null
): string {
    switch (mode) {
        case 'current':
            return 'Plan actual';
        case 'header':
            return `PLAN ${formatPlanId(planId)}`;
        case 'active':
            return `${formatPlanId(planId)} ACTIVO`;
    }
}
